export const API_URL = "https://instadrop-server.herokuapp.com";
export const USER_CLIENT_URL = "https://pay.instadrop.com.ng";
// export const API_URL = "http://localhost:8000";
